/**
 * 自定义字段适配器
 *
 * 将 `(value, onChange) => ReactNode` 形式的自定义渲染函数
 * 适配为 antd Form.Item 所需的受控组件接口。
 *
 * 被 DynamicFormModal 和 SearchFilterBar 共同使用。
 */

import type React from 'react';

/**
 * CustomFieldAdapter 属性
 */
export interface CustomFieldAdapterProps {
  /** 自定义渲染函数 */
  render: (value: unknown, onChange: (v: unknown) => void) => React.ReactNode;
  /** 受控值 (由 Form.Item 注入) */
  value?: unknown;
  /** 变更回调 (由 Form.Item 注入) */
  onChange?: (v: unknown) => void;
}

/**
 * 自定义字段适配器 — 将 render 函数适配为受控组件
 *
 * @example
 * ```tsx
 * <Form.Item name="custom">
 *   <CustomFieldAdapter
 *     render={(value, onChange) => (
 *       <MyCustomInput value={value} onChange={onChange} />
 *     )}
 *   />
 * </Form.Item>
 * ```
 */
export function CustomFieldAdapter({
  render,
  value,
  onChange,
}: CustomFieldAdapterProps): React.ReactElement {
  return <>{render(value, onChange ?? (() => {}))}</>;
}
